import { render, staticRenderFns } from "./NetaNewEventComponent.vue?vue&type=template&id=57842fc7&"
import script from "./NetaNewEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewEventComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports